import { z } from "zod";
import { SlotId } from "./slot-id.js";

// isolatedDeclarations: define output shape as TS interface, annotate
// Zod const with z.ZodType<Interface> so tsc can emit declarations without
// reading across module boundaries (D-15 paranoid-strict tsconfig).
//
// exactOptionalPropertyTypes: optional `defaultPlacement` field typed as
// `SlotId | undefined` to match ZodOptional's output type.
//
// ISSUE-9 FIX (Plan 06 Task 2): `defaultPlacement` tightened from `string | undefined`
// to `SlotId | undefined` (Consensus #6 closure).
//
// D-06: `controls` is an engine-only zone and must NEVER appear in
// `supportedPlacements`. The enum is exactly ["options", "main"].

export interface WidgetTemplate {
  id: string;
  name: string;
  charter: string;
  configSchema: z.ZodTypeAny;
  supportedPlacements: ReadonlyArray<"options" | "main">;
  defaultPlacement?: SlotId | undefined;
}

export const WidgetTemplate: z.ZodType<WidgetTemplate> = z.strictObject({
  id: z
    .string()
    .min(1)
    .max(50)
    .regex(/^[a-z][a-z0-9-]*$/, "kebab-case"),
  name: z.string().min(1).max(100),
  charter: z.string().min(1).max(500),
  // configSchema: z.ZodTypeAny is not itself Zod-validatable — z.any() accepts
  // any ZodType at runtime. Contract enforced by review and README documentation.
  configSchema: z.any(),
  // D-06: controls is engine-only; only "options" and "main" are author-placeable
  supportedPlacements: z.array(z.enum(["options", "main"])).min(1),
  // ISSUE-9 FIX: tightened to SlotId.optional() (was z.string().min(1).optional())
  defaultPlacement: SlotId.optional(),
});
